import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import anime from 'animejs';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import dataModel from '../../../../models/DataModel';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';

import { Area, ResponsiveContainer, Label, ComposedChart, Bar, YAxis, XAxis, Tooltip, ReferenceArea } from 'recharts';
import _ from 'lodash';

import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import DataSource from '../../../../dao/DataSource/DataSource';
import CustomToolTip from './CustomToolTip';
import filterBlueIcon from '../../../../assets/images/project-filter-icon-blue.svg';
import expand from '../../../../assets/images/expand-icon.svg';
import collapse from '../../../../assets/images/collapse-icon.svg';
import './ProjectTimeline.scss';
import PropTypes from 'prop-types';
import ProjectActivityPopup from './ProjectActivityPopup';
import ReportFilter from '../../../../containers/ManagerDashboard/ReportFilter';
import ProjectTimelineFilters from './ProjectTimelineFilters';
import ExportReport from '../../../../containers/ManagerDashboard/ExportReport';

const ONE_MINUTE = 1000 * 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;
const ONE_WEEK = ONE_DAY * 7;
const ONE_MONTH = ONE_DAY * 30;

const endDays =[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const endLeapDays =[31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function getLocalDateTime(gmtDate, dayOnly) {
  let myDate = new Date(gmtDate);
  if (dayOnly) {
    myDate = new Date(myDate.getMonth() + 1 + '/' + myDate.getDate() + '/' + myDate.getFullYear());
  }
  return myDate;
}

function formatDate(date) {
  var day = date.getDate();
  var monthIndex = date.getMonth() + 1;

  return monthIndex + '/' + day;
}

class CustomizedDot extends React.Component {
  render() {
    const { cx, cy, onClick, payload } = this.props;

    if (payload.events == 0) {
      return null;
    }

    return (
      <g >
        <circle cx={cx} cy={cy - 5} r={5} stroke="#184E78" fill="#184E78" onClick={e => { onClick(payload); }} />
        <text x={cx} y={cy - 15} fontSize={12} fontFamily="Open Sans" textAnchor="middle">{payload.events}</text>
        </g>
      );
  }
};

let  dummyData = [
];

var monthNames = [
  'January', 'February', 'March',
  'April', 'May', 'June', 'July',
  'August', 'September', 'October',
  'November', 'December',
];

var abrMonthNames = [
  'Jan', 'Feb', 'Mar',
  'Apr', 'May', 'Jun', 'Jul',
  'Aug', 'Sep', 'Oct',
  'Nov', 'Dec',
];

function formatDateRange(dataElement) {
  switch (dataElement.timePeriodLabel) {
  case 'MONTHS':
    const month = dataElement.startTime.getMonth();
    return abrMonthNames[month] + ' ' + dataElement.startTime.getFullYear();
  case 'WEEKS':
    return formatDate(dataElement.startTime) + '-' + formatDate(dataElement.endTime);
  case 'DAYS':
    return formatDate(dataElement.startTime);
  case 'HOURS':
    return dataElement.startTime.getHours() + ':00';
  default:
    return formatDate(dataElement.startTime);
  }
}

const DottedBar = (props) => {
  let {
    fill, x, y, width, height,
  } = props;

  if (Number.isNaN(y) || !y) {
    y = 0;
  }
  if (Number.isNaN(height)) {
    height = 0;
  }
  return <g >
    <line className="dotted-bar" style={{ strokeWidth: 5 }} x1={x + width / 2} x2={x + width / 2} y1={y} y2={y + height} width={width} height={height} stroke={'#ffffff00'} />;
    <line strokeDasharray="10, 5" style={{ strokeWidth: 1 }} x1={x + width / 2} x2={x + width / 2} y1={y} y2={y + height} width={width} height={height} stroke={fill} />;
  </g>;
};

DottedBar.propTypes = {
  fill: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

class CustomXTickLabel extends PureComponent {
  render() {
    const {
      x, y, index, data,
    } = this.props;

    if (index == 0 || index == data.length - 1) {
      const d = data[index];
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={23} textAnchor="middle">{d.xTickLabel}</text>
        </g>
      );
    }
    else{
      return (
        <g transform={`translate(${x},${y})`}>
          <text x={0} y={20} ></text>
        </g>
      );
    }
  }
}
export class ProjectTimeline extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      initialized: false,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin',
      top2: 'dataMax+20',
      bottom2: 'dataMin-20',
      animation: true,
    };
    
    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });

    this.renderCustomizedLabel = this.renderCustomizedLabel.bind(this);
    this.getAxisYDomain = this.getAxisYDomain.bind(this);
    this.xTickFormat = this.xTickFormat.bind(this);
    this.yTickFormat = this.yTickFormat.bind(this);
    this.isFilterEmpty = this.isFilterEmpty.bind(this);

  }

  xTickFormat(xIndex) {
    const index = parseInt(xIndex, 10);
    if (this.state.data && this.state.data.length > 0) {
      const d = this.state.data[index];
      if (index == 0 || index == this.state.data.length - 1) {
        return d.xTickLabel ? d.xTickLabel : 'blank';
      }
      else {
        return '';
      }
    }
    else {
      const d = dummyData[index];
      if (index == 0 || index == dummyData.length - 1) {
        return d.xTickLabel ? d.xTickLabel : 'blank';
      }
      else {
        return '';
      }
    }
  }

  yTickFormat(yLabel) {
    return '';
  }

  getAxisYDomain(from, to, ref, offset) {
    if (from > to) {
      let t = from;
      from = to;
      to = t;
    }

    // get dates now
    const fromDate = this.state.data[from].startTime;
    const toDate = this.state.data[to].endTime;
    const refData = this.state.data.filter(d => {
      return d.startTime >= fromDate && d.endTime <= toDate;
    });
    if (refData.length > 0) {
      let [bottom, top] = [refData[0][ref], refData[0][ref]];
      refData.forEach((d) => {
        if (d[ref] > top) top = d[ref];
        if (d[ref] < bottom) bottom = d[ref];
      });
      const startTime = refData[0].startTime;
      const endTime = refData[refData.length - 1].endTime;
      return [(bottom | 0), (top | 0) + offset, startTime, endTime];
    }
    else {
      return [
        'dataMin',
        'dataMax', null, null];
    }
  }

  handleEventHistoryUpdate(projectActivity) {
    this.setState({ initialized: true });
    if (this.projectActivityDataSource && projectActivity && projectActivity.event_histories && projectActivity.event_histories.length > 0) {
      this.setState({ projectActivity: projectActivity.event_histories });
      if (!this.isFilterEmpty(this.projectActivityDataSource.filter)) {
        this.handleData(projectActivity.event_histories, null, null, this.projectActivityDataSource.filter);
        this.setState({ filterActive: true, filter: this.projectActivityDataSource.filter });
      }
      else {
        this.handleData(projectActivity.event_histories);
      }
    }
  }

  handleProjectRetrieval(project) {
    this.setState({ project });
    this.projectActivityDataSource.current();
  }

  handleInitializeDataSource() {
    if (this.projectActivityDataSource) {
      this.projectActivityDataSource.release();
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }

    this.projectDataSource = new DataSource('Project', this.props.project_id, { project: { builds: {}, location: {}, users: { }, project_contacts: { user: {} }  } },
      this.handleProjectRetrieval, { include_location_builds: true });
    this.projectActivityDataSource = new CollectionDataSource('ProjectActivityCollection', 'EventHistory', {
      event_histories: {
        additionalFields: ['completion_criterion', 'task', 'build', 'location'],
        activity: {},
        activity_sub_type: {},
        user_who_performed_action: { additionalFields: ['profile_image'] },
      },
    }, this.handleEventHistoryUpdate, this.props.project_id, this.props.currentCompany.id);

    this.projectDataSource.get();
  }

  componentDidMount() {
    this.handleDummyData();
    if (this.props.currentUser && this.props.currentCompany && this.props.project_id) {
      this.handleInitializeDataSource();
    }
  }

  componentWillUnmount() {
    if (this.projectActivityDataSource) {
      this.projectActivityDataSource.release();
      this.projectActivityDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    clearInterval(this.updateDateInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.currentCompany != this.props.currentCompany && this.props.currentCompany) ||
      (prevProps.currentUser != this.props.currentUser && this.props.currentUser)) {
      this.handleInitializeDataSource();
    }
    else if (prevProps.project_id != this.props.project_id) {
      this.handleInitializeDataSource();
    }
    else if (prevProps.expanded != this.props.expanded) {
      if (!this.props.expanded) {
        if (!this.isFilterEmpty(this.projectActivityDataSource.filter)) {
          this.handleData(this.state.projectActivity, null, null, this.projectActivityDataSource.filter);
          this.setState({ filterActive: true, filter: this.projectActivityDataSource.filter });
        }
        else {
          this.handleData(this.state.projectActivity);
        }
      }
    }
  }

  handleGetPeriod(elapsedTime, setLabel) {
    let timePeriod = ONE_DAY;

    if (elapsedTime > (ONE_WEEK * 32)) {
      if (setLabel) {
        this.xAxisLabel = 'MONTHS';
      }
      timePeriod = ONE_MONTH;
    }
    else if (elapsedTime > (ONE_WEEK * 5)) {
      if (setLabel) {
        this.xAxisLabel = 'WEEKS';
      }
      timePeriod = ONE_WEEK;
    }
    else if (elapsedTime > ONE_DAY * 2) {
      if (setLabel) {
        this.xAxisLabel = 'DAYS';
      }
      timePeriod = ONE_DAY;
    }
    else {
      if (setLabel) {
        this.xAxisLabel = 'HOURS';
      }
      timePeriod = ONE_HOUR;
    }
    return timePeriod;
  }

  handleDummyData() {
    let elapsedTime = new Date() - new Date(new Date('January 1, 2019').toUTCString());

    let timePeriod = this.handleGetPeriod(elapsedTime, true);

    let beginTime = new Date(new Date('January 1, 2019').toUTCString());
    let finishTime = new Date();

    let startTime = new Date(Math.floor(beginTime.getTime() / timePeriod) * timePeriod);
    const endTime = new Date(Math.floor(finishTime.getTime() / timePeriod) * timePeriod + (ONE_DAY - 1));

    let buckets = [];
    let periodNum = 1;

    let maxEntries = 0;
    while (endTime - startTime >= 0) {
      let displayTimeLabel = null;
      if (timePeriod == ONE_MONTH) {
        displayTimeLabel = monthNames[startTime.getMonth()] + ' ' + startTime.getFullYear();
      }
      else {
        displayTimeLabel = abrMonthNames[startTime.getMonth()] + ' ' + startTime.getDate() + ', ' + startTime.getFullYear();
      }
      let entry = {
        bucketEntries: [], startTime: startTime, endTime: new Date(startTime.getTime() + timePeriod),
        numberEntries: Math.floor(Math.random() * 30), timePeriod: timePeriod,
        period: periodNum++,
        timePeriodLabel: this.xAxisLabel,
        xLabel: displayTimeLabel,
      };
      buckets.push(entry);
      if (maxEntries < entry.numberEntries) {
        maxEntries = entry.numberEntries;
      }
      startTime = new Date(startTime.getTime() + timePeriod);
    }

    let data = [];
    let index = 0;
    const pixelsPerEvent = 150 / maxEntries;
    const displayPixels = 18;
    for (let i = 0; i < buckets.length; i++) {
      const eventHistory = buckets[i];
      const ne = eventHistory.numberEntries;
      let dataElement = {
        events: ne,
        displayEvents: ne == 0 ? 0 : (((ne * pixelsPerEvent) < displayPixels) ? Math.ceil(displayPixels / pixelsPerEvent) : ne),
        delaysCount: eventHistory.delaysCount,
        workQualityCount: eventHistory.workQualityCount,
        workCompletionCount: eventHistory.workCompletionCount,
        period: eventHistory.period,
        xTickLabel: eventHistory.xLabel,
        xIndex: index++,
        startTime: new Date(eventHistory.startTime),
        endTime: new Date(eventHistory.endTime),
        timePeriod: eventHistory.timePeriod,
        timePeriodLabel: eventHistory.timePeriodLabel,
        actualEvents: eventHistory.actualEvents,
      };
      data.push(dataElement);
    }

    dummyData = data;

  }

  handleData(projectActivity, optStartTime, optEndTime, filter) {

    if (projectActivity && projectActivity.length) {

      let userIds;
      let companyIds;
      let eventTypeNames;
      let locationIds;
      let buildIds;
      if (filter) {
        if (filter.timeframe) {
          optStartTime = filter.timeframe.startTime ? new Date(filter.timeframe.startTime) : null;
          optEndTime = filter.timeframe.endTime ? new Date(filter.timeframe.endTime) : null;
        }
        if (filter.vendorCompanies) {
          companyIds = filter.vendorCompanies.map(vc => {
            return vc.id ? vc.id : vc.type;
          });
        }
        if (filter.projectMembers) {
          userIds = filter.projectMembers.map(pm => {
            return pm.id ? pm.id : pm.type;
          });
        }
        if (filter.locations) {
          locationIds = filter.locations.map(location => {
            return location.id ? location.id : location.type;
          });
        }
        if (filter.builds) {
          buildIds = [];
          filter.builds.forEach(build => {
            if (build.location_id && locationIds && locationIds.length > 0) {
              if (locationIds.find(id => { return id == build.location_id; })) {
                return buildIds.push(build.id ? build.id : build.type);
              }
            }
            else {
              return buildIds.push(build.id ? build.id : build.type);
            }
          });
        }
        if (filter.eventTypes) {
          eventTypeNames = [];
          filter.eventTypes.forEach(et => {
            switch (et.type) {
            case 'delays':
              eventTypeNames.push('Delay Submitted');
              break;
            case 'completion':
              eventTypeNames.push('Attachment Upload');
              eventTypeNames.push('Completion Step is Completed');
              eventTypeNames.push('Inventory Added');
              break;
            case 'quality':
              eventTypeNames.push('Rejected');
              eventTypeNames.push('Accepted');
              break;
            default:
              break;
            }
          });
        }
      }
      if (optStartTime) {
        optStartTime = getLocalDateTime(optStartTime, true);
      }
      if (optEndTime) {
        optEndTime = new Date(getLocalDateTime(optEndTime, true).getTime() + (ONE_DAY - 1));
      }

      let date;
      let dateString;
      let newDate;

      // Get buckets
      
      let beginTime = getLocalDateTime(projectActivity[0].created_at, true);
      const projectCompletedDate = new Date(this.state.project.completed_at);
      let finishTime = this.state.project.status == 'complete' ? new Date(getLocalDateTime(projectCompletedDate, true).getTime() + (ONE_DAY - 1)) :
        new Date(getLocalDateTime(new Date(), true).getTime() + (ONE_DAY - 1));

      if (optStartTime) {
        beginTime = optStartTime;
      }
      if (optEndTime) {
        finishTime = optEndTime;
      }
      const elapsedTime = finishTime - beginTime;

      let timePeriod = this.handleGetPeriod(elapsedTime, true);

      if (filter && filter.timeframe) {
        filter.timeframe.timePeriodLabel = this.xAxisLabel;
        this.projectActivityDataSource.filter = Object.assign({}, filter);
      }

      if (timePeriod == ONE_MONTH) {
        let dateString = (new Date(beginTime).getMonth() + 1) + '/1/' + new Date(beginTime).getFullYear();
        beginTime = new Date(dateString);

        date = new Date(finishTime);
        dateString = (date.getMonth() + 1) + '/' + (date.getFullYear() % 4 == 0 ? endLeapDays[date.getMonth()] : endDays[date.getMonth()]) + '/' + date.getFullYear();
        const newDate = new Date(dateString);
        finishTime = new Date(newDate.getTime() + (ONE_DAY - 1));
      }

      let startTime = beginTime;
      let endTime = finishTime;
      
      if (optStartTime || optEndTime) {
        if (!filter) {
          this.projectActivityDataSource.filter = { timeframe: { startTime, endTime, timePeriodLabel: this.xAxisLabel } };
          this.setState({ filterActive: true, filter });
        }
      }

      let buckets = [];
      let periodNum = 1;
      let maxEntries = 0;
      while (finishTime - startTime >= 0) {
        let endTime;
        if (timePeriod == ONE_MONTH) {
          dateString = (startTime.getMonth() + 1) + '/' + (startTime.getFullYear() % 4 == 0 ? endLeapDays[startTime.getMonth()] : endDays[startTime.getMonth()]) + '/' + startTime.getFullYear();
          newDate = new Date(dateString);
          endTime = new Date(newDate.getTime() + ONE_DAY - 1);
        }
        else {
          endTime = new Date(getLocalDateTime(startTime).getTime() + timePeriod - 1);
        }

        buckets.push({
          bucketEntries: [], startTime: startTime, endTime: endTime,
          numberEntries: 0, timePeriod: timePeriod,
          delaysCount: 0,
          workCompletionCount: 0,
          workQualityCount: 0,
          period: periodNum++,
          timePeriodLabel: this.xAxisLabel,
          actualEvents: [],
          xLabel: timePeriod == ONE_MONTH ? monthNames[startTime.getMonth()] + ' ' + startTime.getFullYear() : abrMonthNames[startTime.getMonth()] + ' ' + startTime.getDate() + ', ' + startTime.getFullYear(),
        });
        if (timePeriod == ONE_MONTH) {
          let month = startTime.getMonth() + 1;
          let year = startTime.getFullYear();
          if (month > 11) {
            month = 0;
            year++;
          }
          dateString = (month + 1) + '/1/' + year;
          startTime = new Date(dateString);
        }
        else {
          startTime = new Date(startTime.getTime() + timePeriod);
        }
      }

      buckets.push({
        bucketEntries: [], startTime: startTime, endTime: new Date(startTime.getTime() + timePeriod - 1),
        numberEntries: 0, timePeriod: timePeriod,
        delaysCount: 0,
        workCompletionCount: 0,
        workQualityCount: 0,
        period: periodNum++,
        timePeriodLabel: this.xAxisLabel,
        actualEvents: [],
        xLabel: timePeriod == ONE_MONTH ? monthNames[startTime.getMonth()] + ' ' + startTime.getFullYear() : abrMonthNames[startTime.getMonth()] + ' ' + startTime.getDate() + ', ' + startTime.getFullYear(),
      });
      
      projectActivity.forEach(eventHistory => {
        let findBucket = getLocalDateTime(eventHistory.created_at);

        let goOn = true;
        if (locationIds) {
          if (!locationIds.find(location_id => {
            return (eventHistory.location && eventHistory.location.id == location_id) ||
                (eventHistory.build && eventHistory.build.location_id == location_id); })) {
            goOn = false;
          }
        }

        if (userIds) {
          if (!userIds.find(user_id => { return eventHistory.user_who_performed_action && eventHistory.user_who_performed_action.id == user_id; })) {
            goOn = false;
          }
        }

        if (companyIds) {
          if (!companyIds.find(company_id => {
            return eventHistory.user_who_performed_action &&
              eventHistory.user_who_performed_action.companies && eventHistory.user_who_performed_action.companies.length > 0 &&
              eventHistory.user_who_performed_action.companies[0].id == company_id;
          })) {
            goOn = false;
          }
        }

        if (buildIds) {
          if (!buildIds.find(build_id => {
            return eventHistory.build && eventHistory.build.id == build_id;
          })) {
            goOn = false;
          }
        }

        if (eventTypeNames) {
          if (!eventTypeNames.find(eventTypeName => { return eventHistory.activity.name == eventTypeName; })) {
            goOn = false;
          }
        }

        if (goOn) {
          let entry = buckets.find(bucket => {
            return findBucket >= bucket.startTime && findBucket <= bucket.endTime;
          });

          if (entry) {
            entry.numberEntries++;
            entry.actualEvents.push(eventHistory);
            switch (eventHistory.activity.name) {
            case 'Delay Submitted':
              entry.delaysCount++;
              break;
            case 'Attachment Upload':
            case 'Completion Step is Completed':
            case 'Inventory Added':
              entry.workCompletionCount++;
              break;
            case 'Rejected':
            case 'Accepted':
              entry.workQualityCount++;
              break;
            default:
              break;
            }
            entry.bucketEntries.push(eventHistory);
            if (maxEntries < entry.numberEntries) {
              maxEntries = entry.numberEntries;
            }
          }
        }
      });

      let data = [];
      let index = 0;
      const pixelsPerEvent = 150 / maxEntries;
      const displayPixels = 18;
      let hasZero = false;
      
      for (let i = 0; i < buckets.length; i++) {
        if (buckets[i]) {
          if (i == buckets.length - 1 && hasZero) {
            continue;
          }
          else {
            const eventHistory = buckets[i];
            const ne = eventHistory.numberEntries;
            let dataElement = {
              events: ne,
              displayEvents: ne == 0 ? 0 : (((ne * pixelsPerEvent) < displayPixels) ? Math.ceil(displayPixels / pixelsPerEvent) : ne),
              delaysCount: eventHistory.delaysCount,
              workQualityCount: eventHistory.workQualityCount,
              workCompletionCount: eventHistory.workCompletionCount,
              period: eventHistory.period,
              xTickLabel: eventHistory.xLabel,
              xIndex: index++,
              startTime: new Date(eventHistory.startTime),
              endTime: new Date(eventHistory.endTime),
              timePeriod: eventHistory.timePeriod,
              timePeriodLabel: eventHistory.timePeriodLabel,
              actualEvents: eventHistory.actualEvents,
            };
            if (!ne) {
              hasZero = true;
            }
            data.push(dataElement);
          }
        }
      }

      if (!filter && !optStartTime && !optEndTime) {
        const originalData = data.map(dataElement => {
          return Object.assign({}, dataElement, { withinSelection: true });
        });
        this.setState({ originalData });
      }

      data.sort((d1, d2) => {
        return d1.startTime < d2.startTime ? -1 : d1.startTime > d2.startTime ? 1 : 0;
      });
      this.setState({ eventHistoryBuckets: buckets, data: data, exportLink: this.handleExport() });
    }
  }

  renderCustomizedLabel(props) {
    const { x, y, width, value } = props;
  
    return (
    <g>
      <rect width={width} height={20} x={x} y={y - 20} fill="White" />
        <text x={x + width / 2} y={y - 12} fill="#4f4f4f" textAnchor="middle" dominantBaseline="middle" fontFamily="Open Sans" fontSize="20px">
          {value}
        </text>
      </g>
    );
  };

  handleMouseOverBar(data, index) {
  }

  handleExpand() {
    if (this.props.expandContract) {
      this.props.expandContract(!this.props.expanded);
    }
  }

  handleBarClick(bar) {
    this.analyticsLogger.logProjectEvent('ProjectActivityCategoriesViewed');
    this.setState({ bar: bar });
  }

  handleClosePopup() {
    this.setState({ bar: null });
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    this.mouseDown = true;
    this.lastClientX = e.clientX;
  }

  handleInitialMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.mouseDown && !this.state.dragXPosition) {
      const dotToStartDragging = document.getElementById(e.target.id);

      const parentRect = dotToStartDragging.parentElement.parentElement.parentElement.getBoundingClientRect();
      const elementRect = dotToStartDragging.getBoundingClientRect();
      const deltax = e.clientX - this.lastClientX;
      const elementLeft = elementRect.left - parentRect.left;
      this.lastClientX = e.clientX;

      const { originalData } = this.state;

      const selected = originalData.filter(de => {
        return de.selected;
      });

      if (selected.length == 2) {
        originalData.forEach(de => {
          if (de.xIndex == parseInt(e.target.id, 10) - 1) {
            de.selected = false;
          }
        });
      }

      this.setState({ movingDot: parseInt(e.target.id, 0) * -1, dragXPosition: elementLeft + deltax });
    }
  }

  handleMouseUp(e) {
    e = this.fixupMouse(e);
    this.mouseDown = false;
    this.dragElement.removeEventListener('pointerup', this.handleMouseUp);
    this.dragElement.removeEventListener('pointermove', this.handleMouseMove);

    if (this.possibleDrop >= 0) {
      this.dragElement.releasePointerCapture(e.event.pointerId);
      this.dropTarget.parentElement.classList.remove('mouse-over');

      this.dragElement = null;

      const otherSelection = this.state.originalData.find(de => {
        return de.selected;
      });
      const dropSelection = this.state.originalData.find(de => {
        return de.xIndex == this.possibleDrop;
      });
      if (dropSelection) {
        let startTime = null;
        let endTime = null;
        if (dropSelection.xIndex < otherSelection.xIndex) {
          startTime = dropSelection.startTime;
          endTime = otherSelection.xIndex == this.state.originalData.length - 1 ? null : otherSelection.endTime;
        }
        else if (dropSelection.xIndex > otherSelection.xIndex){
          startTime = otherSelection.xIndex == 0 ? null : otherSelection.startTime;
          endTime = dropSelection.endTime;
        }
        else {
          startTime = dropSelection.startTime;
          endTime = new Date(dropSelection.startTime.getTime() + ONE_DAY - 1);
        }
        this.handleData(this.state.projectActivity, startTime, endTime);
      }
      this.setState({ movingDot: null, dragXPosition: null });
    }
    else {
      this.state.originalData.forEach(de => {
        if (de.xIndex == Math.abs(parseInt(this.dragElement.id, 10)) - 1) {
          de.selected = true;
        }
      });
      this.dragElement.releasePointerCapture(e.event.pointerId);
      this.dragElement = null;
    }
    this.setState({ movingDot: null, dragXPosition: null });
  }

  handleCheckRectOverlap(rect1, rect2) {
    // all we care about is the x-axis overlap
    if ((rect1.left >= rect2.left && rect1.left <= rect2.right) ||
      (rect2.left >= rect1.left && rect2.left <= rect1.right) ||
      (rect1.right <= rect2.right && rect1.right >= rect2.left) ||
      (rect2.right <= rect1.right && rect2.right >= rect1.left)) {
      return true;

    }
    return false;
  }
  
  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.state.movingDot) {
      if (!this.dragElement.hasPointerCapture(e.event.pointerId)) {
        this.dragElement.setPointerCapture(e.event.pointerId);
      }
      const parentRect = this.dragElement.parentElement.getBoundingClientRect();
      const elementRect = this.dragElement.getBoundingClientRect();
      const deltax = e.clientX - this.lastClientX;
      let elementLeft = elementRect.left - parentRect.left;
      if (elementLeft < 0) {
        elementLeft = 0;
      }
      else {
        if (elementLeft + elementRect.width > parentRect.width) {
          elementLeft = parentRect.width - elementRect.width;
        }
      }
      this.lastClientX = e.clientX;

      // See if it is over something

      let overlap = false;

      const dropTargets = document.getElementsByClassName('element-dot');
      this.dropTarget = null;
      if (dropTargets) {
        for (let i = 0; i < dropTargets.length; i++){
          let el = dropTargets[i];
          if (el.id == this.dragElement.id) {
            continue;
          }
          el.parentElement.classList.remove('mouse-over');
          const rect = el.getBoundingClientRect();
          if (this.handleCheckRectOverlap(rect, elementRect)) {
            this.dropTarget = el;
            el.parentElement.classList.add('mouse-over');
            break;
          }
        }
        if (this.dropTarget) {
          overlap = true;
          this.possibleDrop = parseInt(this.dropTarget.id, 10) - 1;
        }
        else {
          this.possibleDrop = null;
        }
      }

      this.setState({ dragXPosition: elementLeft + deltax, canDrop: overlap });
    }
  }

  handleSetDragElement(e, targetId) {
    if (e) {
      this.dragElement = e;
      this.dragElement = document.getElementById(targetId);
      this.dragElement.addEventListener('pointerup', this.handleMouseUp);
      this.dragElement.addEventListener('pointermove', this.handleMouseMove);
    }
  }

  getDateRange() {
    let dateRange = this.state.initialized ? 'No Data yet…get started on the project to use this Timeline!' : '';
    if (this.state.data && this.state.data.length > 0) {
      let startTime = this.state.data[0].startTime;
      dateRange = abrMonthNames[startTime.getMonth()] + ' ' + startTime.getFullYear() + ' - ';
      
      let endTime = this.state.data.length > 1 ? this.state.data[this.state.data.length - 1].endTime : startTime;

      dateRange += abrMonthNames[endTime.getMonth()] + ' ' + endTime.getFullYear();
      
    }
    return dateRange;
  }

  getMinimizedDisplay(dateRange) {
    return (<div className="event-analysis-chart not-expanded">
    <div className="event-analysis-chart-body not-expanded">
      <div className="event-analysis-title-line not-expanded">
        <img className="expand-contract not-expanded" alt="expand" src={expand} onClick={this.handleExpand} />
        <div className="event-analysis-title">
          Project Timeline
    </div>
        <div className="event-analysis-date-range">
          {dateRange}
        </div>
      </div>
    </div>
  </div>);
  }

  handleOnClick(e) {
    const { originalData } = this.state;
    let id = e.target.id;
    if (id.indexOf('label_') >= 0) {
      id = id.substring(6, id.length - 6);
    }

    const selected = originalData.find(de => {
      de.selected = true;
      return de.xIndex == parseInt(id, 10) - 1;
    });

    if (selected) {
      if (selected.xIndex == 0 || selected.xIndex == originalData.length - 1) {
        if (this.selectionHistory && this.selectionHistory.length > 0) {
          const startEnd = this.selectionHistory.splice(this.selectionHistory.length - 1, 1);
          this.currentSelection = startEnd[0];
          this.handleData(this.state.projectActivity, startEnd[0].startTime, startEnd[0].endTime);
        }
        else {
          this.currentSelection = null;
          this.handleData(this.state.projectActivity, null, null);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
        }
      }
      else {
        let startTime = selected.startTime;
        let endTime = selected.endTime;
        if (!this.selectionHistory) {
          this.selectionHistory = [];
        }
        if (this.currentSelection)
        {
          this.selectionHistory.push(this.currentSelection);          
        }
        this.currentSelection = { startTime, endTime };
        this.handleData(this.state.projectActivity, startTime, endTime);
      }
    }
  }

  getExpandLine() {
    // First Group of unselected
    
    const { originalData } = this.state;
    if (originalData) {
      let firstGroup = true;
      const unexpandedData1 = originalData.filter(dataElement => {
        if (dataElement.withinSelection) {
          firstGroup = false;
          return false;
        }
        else if (firstGroup) {
          return true;
        }
        else {
          return false;
        }
      });

      const unselectedExpandDots1 = unexpandedData1.map(dataElement => {
        let elementLabel = formatDateRange(dataElement);
        return <div key={dataElement.xIndex} className="element-marker first-group">
          <div className={'element-dot' + (dataElement.selected ? ' selected' : ' not-selected') + (dataElement.timePeriodLabel != 'HOURS' ? ' selectable' : '')} id={dataElement.xIndex + 1}
            onPointerDown={dataElement.selected ? this.handleMouseDown : undefined} onClick={!dataElement.selected && dataElement.timePeriodLabel != 'HOURS' ? this.handleOnClick : undefined}
            onPointerMove={dataElement.selected ? this.handleInitialMouseMove : undefined}
          >
          </div>
          <div className="element-label">{elementLabel}</div>
        </div>;
      });

      const expandedData = originalData.filter(dataElement => {
        return dataElement.withinSelection;
      });

      const selectedExpandDots = expandedData.map(dataElement => {
        let elementLabel = formatDateRange(dataElement);
        return <div key={dataElement.xIndex} className="element-marker">
          <div className={'element-dot' + (dataElement.selected ? ' selected' : ' not-selected') + (dataElement.timePeriodLabel != 'HOURS' ? ' selectable' : '')} id={dataElement.xIndex + 1}
            onPointerDown={dataElement.selected ? this.handleMouseDown : undefined} onClick={!dataElement.selected && dataElement.timePeriodLabel != 'HOURS' ? this.handleOnClick : undefined}
            onPointerMove={dataElement.selected ? this.handleInitialMouseMove : undefined}
          >
          </div>
          <div id={'label_' + (dataElement.xIndex + 1)} className="element-label" onClick={!dataElement.selected && dataElement.timePeriodLabel != 'HOURS' ? this.handleOnClick : undefined}>{elementLabel}</div>
        </div>;
      });
      
      let secondGroup = false;
      const unexpandedData2 = originalData.filter(dataElement => {
        if (dataElement.withinSelection) {
          secondGroup = true;
          return false;
        }
        else if (secondGroup) {
          return true;
        }
        else {
          return false;
        }
      });
      const unselectedExpandDots2 = unexpandedData2.map(dataElement => {
        let elementLabel = formatDateRange(dataElement);
        return <div key={dataElement.xIndex} className="element-marker last-group">
          <div className={'element-dot' + (dataElement.selected ? ' selected' : ' not-selected') + (dataElement.timePeriodLabel != 'HOURS' ? ' selectable' : '')} id={dataElement.xIndex + 1}
            onPointerDown={dataElement.selected ? this.handleMouseDown : null} onClick={!dataElement.selected && dataElement.timePeriodLabel != 'HOURS' ? this.handleOnClick : null}
            onPointerMove={dataElement.selected ? this.handleInitialMouseMove : null}
          >
          </div>
          <div className="element-label">{elementLabel}</div>
        </div>;
      });

      let selectPercents = 'full';
      if (unselectedExpandDots1.length > 0 && unselectedExpandDots2.length > 0) {
        selectPercents = 'fifty middle-group';
      }
      else if (unselectedExpandDots1.length > 0 || unselectedExpandDots2.length > 0) {
        selectPercents = 'seventy-five middle-group';
      }

      let unselectedDisplay1 = null;
      if (unselectedExpandDots1.length > 0) {
        unselectedDisplay1 = <div className={'selected-unselected-group first-group'}>
          {unselectedExpandDots1}
        </div>;
      }

      let selectedDisplay = null;
      if (selectedExpandDots.length > 0) {
        selectedDisplay = <div className={'selected-unselected-group ' + (selectPercents)}>
          {selectedExpandDots}
        </div>;
      }

      let unselectedDisplay2 = null;
      if (unselectedExpandDots2.length > 0) {
        unselectedDisplay2 = <div className={'selected-unselected-group last-group'}>
          {unselectedExpandDots2}
        </div>;
      }

      let movingDotElement = null;
      if (this.state.movingDot) {
        movingDotElement = <div key={this.movingDot} style={{ left: this.state.dragXPosition }} className={'moveable-element-dot' + (this.state.canDrop ? ' can-drop' : '')} id={this.state.movingDot}
          ref={e => this.handleSetDragElement(e, this.state.movingDot)} />;
      }

      return <div className="expand-line">
        {unselectedDisplay1}
        {selectedDisplay}
        {unselectedDisplay2}
        {movingDotElement}
      </div>;
    }
  }

  handleExpander(payload) {
    if (payload.timePeriodLabel != 'HOURS') {
      this.handleData(this.state.projectActivity, payload.startTime, payload.endTime);
    }
  }

  async handleFilterActive() {
    if (!this.filterInProgress) {
      this.filterInProgress = true;
      if (!this.state.filterDisplayed) {
        this.analyticsLogger.logProjectEvent('ProjectActivityFiltered');
      }
      const filterDisplayed = !this.state.filterDisplayed;
      this.setState({ filterDisplayed });
      if (!this.state.filterDisplayed) {
        await anime({
          targets: '.ProjectTimelineFilter',
          height: 169,
          easing: 'easeInOutCubic',
          duration: 500,
          complete: () => {
            document.querySelector('.ProjectTimelineFilter').style.overflow = 'inherit';
            document.querySelector('.ProjectTimelineFilters').style.overflow = 'inherit';
            this.filterInProgress = false;
          },

        });
      }
      else {
        await anime({
          targets: '.ProjectTimelineFilter',
          height: 0,
          easing: 'easeInOutCubic',
          duration: 500,
          begin: () => {
            document.querySelector('.ProjectTimelineFilter').style.overflow = 'hidden';
            document.querySelector('.ProjectTimelineFilters').style.overflow = 'hidden';
          },
          complete: () => {
            this.filterInProgress = false;
          },
        });
      }

      let filter = this.projectActivityDataSource.filter;
      this.projectActivityDataSource.filter = { ...filter };
    }
  }

  isFilterEmpty(filter) {
    return _.isEmpty(filter) || ((!filter.vendorCompanies || filter.vendorCompanies.length == 0) &&
      (!filter.projectMembers || filter.projectMembers.length == 0) && !filter.timeframe && !filter.eventTypes && !filter.locations &&
      !filter.builds);
  }

  handleFilterChange(filter) {
    if (!this.isFilterEmpty(filter)) {
      // TODO: move this to internals of filter
      this.setState({ filterActive: true, filter });
    }
    else {
      this.setState({ filterActive: false, filter });
    }
    this.animateIn = true;
    this.firstTime = false;
    this.projectActivityDataSource.filter = Object.assign({}, filter);
    this.handleData(this.state.projectActivity, null, null, filter);
  }

  handleExport() {
    const collectionFilter = this.projectActivityDataSource.filter;
    const vendorCompanies = collectionFilter && collectionFilter.vendorCompanies ? collectionFilter.vendorCompanies.map(pt => { return pt.type ? pt.type : pt.id ? pt.id: pt;}).join(',') : '';
    const projectMembers = collectionFilter && collectionFilter.projectMembers ? collectionFilter.projectMembers.map(pm => { return pm.type ? pm.type : pm.id ? pm.id: pm;}).join(',') : '';
    const eventTypes = collectionFilter && collectionFilter.eventTypes ? collectionFilter.eventTypes.map(et => { return et.type ? et.type : et.id ? et.id: et;}) : '';

    let exportEventTypes;
    if (eventTypes) {
      exportEventTypes = [];
      eventTypes.forEach(et => {
        switch (et) {
        case 'delays':
          exportEventTypes.push('\'Delay Submitted\'');
          break;
        case 'completion':
          exportEventTypes.push('\'Attachment Upload\'');
          exportEventTypes.push('\'Completion Step is Completed\'');
          exportEventTypes.push('\'Inventory Added\'');
          break;
        case 'quality':
          exportEventTypes.push('\'Rejected\'');
          exportEventTypes.push('\'Accepted\'');
          break;

        default:
          break;
        }
      });
      exportEventTypes = exportEventTypes.join(',');
    }
    const pathname = process.env.REACT_APP_API + '/projects/export_project_timeline';
    let search = ( 
      '?current_company=' + this.props.currentCompany.id
      + '&project_id=' + this.props.project_id
      + (vendorCompanies ? '&vendor_companies=' + vendorCompanies: '')
      + (projectMembers ? '&project_members=' + projectMembers : '')
      + (eventTypes ? '&event_types=' + exportEventTypes : '')
    );

    if (collectionFilter && collectionFilter.timeframe && (collectionFilter.timeframe.startTime || collectionFilter.timeframe.endTime)) {
      let sTime = new Date(collectionFilter.timeframe.startTime);
      let eTime = new Date(collectionFilter.timeframe.endTime);

      search += `&start_time=${(sTime.getMonth() + 1) + '/' + sTime.getDate() + '/' + sTime.getFullYear() + ' ' + sTime.getHours() + ':00' }`;
      search += `&end_time=${(eTime.getMonth() + 1) + '/' + eTime.getDate() + '/' + eTime.getFullYear() + ' ' + eTime.getHours() + ':00' }`;

    }
    
    // search += "&filtering=" + recordDescriptorProcessing.getEncodedForFastSerializer()

    search += `&token=${localStorage.token}`;
    
    return pathname + search;    
  }

  handleLogExport() {
    this.analyticsLogger.logProjectEvent('ProjectActivityExported');
  }

  render() {
    const {
      data, left, right, refAreaLeft, refAreaRight, top, bottom, projectActivity,
    } = this.state;

    if (!this.state.project) {
      return null;
    }

    let dateRange = this.getDateRange();

    let popup = null;
    if (this.state.bar) {
      popup = <ProjectActivityPopup
        key={this.state.bar.x}
        projectActivity={projectActivity}
        closePopup={this.handleClosePopup}
        handleEventClickThrough={this.props.handleEventClickThrough}
        bar={this.state.bar} />;
    }
    let dataCount = 0;
    if (data && data.length != 0) {
      data.filter(d => { 
        dataCount += d.events;
        return false;
      });
    }
    if (!this.props.expanded) {
      return this.getMinimizedDisplay(dateRange);
    }
    else {

      const projectTimelineFilter = (
        <div className='project-timeline-filter-container-outer'>
          <ReportFilter 
            isVertical={false}
            hideTabIndicator={false}
            altClassName={'ProjectTimelineFilter'}
          >
            <ProjectTimelineFilters
              selectedFilters={this.projectActivityDataSource && this.projectActivityDataSource.filter}
              project={this.state.project}
              handleFilterChange={this.handleFilterChange}
              isVertical={false}
              startDate={projectActivity ? new Date(projectActivity[0].created_at) : null}
              endDate={projectActivity && projectActivity.length ? new Date(projectActivity[projectActivity.length - 1].created_at) : null}
              currentCompany={this.props.currentCompany}
              /> 
          </ReportFilter>
        </div>
      );

      const hasData = dataCount || !this.state.initialized;  // Don't want to display default data if not initialized yet
  
      const chartColor = hasData ? '#184E78' : '#585858';
      return (
        <div className="event-analysis-chart">
          {popup}
          <div className="event-analysis-chart-body">
            <div className="event-analysis-title-line">
              <img className="expand-contract" alt="expand" src={collapse} onClick={this.handleExpand} />
              <div className="event-analysis-title">
                Project Timeline
            </div>

              <div className="event-analysis-date-range">
                {hasData ? dateRange : 'No Data yet…get started on the project to use this Timeline'}
              </div>
              <div className={'project-timeline-filter-outer'}>
                {projectTimelineFilter}
                <div 
                  className={'project-timeline-filter' + (this.state.filterDisplayed ? ' project-timeline-filter__active' : '')}
                  onClick={this.handleFilterActive}
                >
                  <img className='filter-icon' src={filterBlueIcon} alt="Filter Timeline" />
                  {this.state.filterActive && <div className='filter-pip'></div>}
                  <p className='filter-text'>{this.textMap.filter.toUpperCase()}</p>
                  {
                    this.state.filterDisplayed && <div className='tab-indicator'></div>
                  }
                </div>
                { hasData &&
                <ExportReport
                  exportLink={this.state.exportLink}
                  logExport={this.handleLogExport}
                  location={'timeline'}
                />
                }
              </div>
            </div>
            <div className={'event-analysis-chart-detail'} style={{ opacity: !hasData ? .3 : 1 }}
              onPointerDown={hasData ? this.handleStartSelection : undefined}               onPointerMove={hasData ? this.handleMoveSelection : undefined}
              onPointerUp={hasData ? this.handleZoomSelection : undefined}>
              <ResponsiveContainer width='100%' height={150}>
                <ComposedChart
                  data={hasData ? data : dummyData}
                >
                  <defs>
                    <linearGradient id="colorArea" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="20%" stopColor={chartColor} stopOpacity={.4} />
                      <stop offset="90%" stopColor={chartColor} stopOpacity={1.0} />
                    </linearGradient>
                  </defs>
                  <XAxis
                    dataKey="xIndex"
                    hide={false}
                    domain={[left, right]}
                    tickLine={false}
                    interval="preserveEnd"
                    tick={<CustomXTickLabel data={hasData ? data : dummyData} />}
                  >
                    <Label value={this.xAxisLabel} offset={0} position="insideBottom" />
                  </XAxis>
                  <YAxis
                    domain={[bottom, top]}
                    tick={false}
                    axisLine={false}
                    hide={false}
                    tickFormatter={this.yTickFormat}
                    type="number"
                    label={{ value: 'ACTIVITY COUNT', angle: -90, position: 'center' }}
                  />
                  {hasData && <Tooltip cursor={false} content={<CustomToolTip />} />}
                  <Area type="linear" dataKey="displayEvents" stroke={chartColor} fill="url(#colorArea)" dot={false} activeDot={hasData && <CustomizedDot onClick={hasData && this.handleExpander}/>} animationDuration={300} />

                  {
                    (refAreaLeft && refAreaRight) ? (
                      <ReferenceArea x1={refAreaLeft} x2={refAreaRight} strokeOpacity={0.3} />) : null
                  }
                  <Bar onClick={hasData ? this.handleBarClick : null} dataKey="displayEvents" barSize={50} fill={chartColor} shape={<DottedBar />} />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
            {!hasData && <div className="no-results-found">No Results Found.</div>}
          </div>
        </div>
      );
    }
  }
}
  
const mapStateToProps = (state, ownProps) => {
  return {
    catastrophicError: state.main.catastrophicError,
    inProgress: state.main.inProgress,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
  };
};
export default connect(mapStateToProps)(ProjectTimeline);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/ProjectTimeline/index.js